import {charHasRotatedVerticalOrientation} from './script_detection';

export const verticalizedCharacterMap = {
    '!': 'ï¸',
    '#': 'ï¼',
    '$': 'ï¼',
    '%': 'ï¼',
    '&': 'ï¼',
    '(': 'ï¸µ',
    ')': 'ï¸¶',
    '*': 'ï¼',
    '+': 'ï¼',
    ',': 'ï¸',
    '-': 'ï¸²',
    '.': 'ã»',
    '/': 'ï¼',
    ':': 'ï¸',
    ';': 'ï¸',
    '<': 'ï¸¿',
    '=': 'ï¼',
    '>': 'ï¹',
    '?': 'ï¸',
    '@': 'ï¼ ',
    '[': 'ï¹',
    '\\': 'ï¼¼',
    ']': 'ï¹',
    '^': 'ï¼¾',
    '_': 'ï¸³',
    '`': 'ï½',
    '{': 'ï¸·',
    '|': 'â',
    '}': 'ï¸¸',
    '~': 'ï½',
    'Â¢': 'ï¿ ',
    'Â£': 'ï¿¡',
    'Â¥': 'ï¿¥',
    'Â¦': 'ï¿¤',
    'Â¬': 'ï¿¢',
    'Â¯': 'ï¿£',
    'â': 'ï¸²',
    'â': 'ï¸±',
    'â': 'ï¹',
    'â': 'ï¹',
    'â': 'ï¹',
    'â': 'ï¹',
    'â¦': 'ï¸',
    'â¯': 'ï¸',
    'â§': 'ã»',
    'â©': 'ï¿¦',
    'ã': 'ï¸',
    'ã': 'ï¸',
    'ã': 'ï¸¿',
    'ã': 'ï¹',
    'ã': 'ï¸½',
    'ã': 'ï¸¾',
    'ã': 'ï¹',
    'ã': 'ï¹',
    'ã': 'ï¹',
    'ã': 'ï¹',
    'ã': 'ï¸»',
    'ã': 'ï¸¼',
    'ã': 'ï¸¹',
    'ã': 'ï¸º',
    'ã': 'ï¸',
    'ã': 'ï¸',
    'ï¼': 'ï¸',
    'ï¼': 'ï¸µ',
    'ï¼': 'ï¸¶',
    'ï¼': 'ï¸',
    'ï¼': 'ï¸²',
    'ï¼': 'ã»',
    'ï¼': 'ï¸',
    'ï¼': 'ï¸',
    'ï¼': 'ï¸¿',
    'ï¼': 'ï¹',
    'ï¼': 'ï¸',
    'ï¼»': 'ï¹',
    'ï¼½': 'ï¹',
    'ï¼¿': 'ï¸³',
    'ï½': 'ï¸·',
    'ï½': 'â',
    'ï½': 'ï¸¸',
    'ï½': 'ï¸µ',
    'ï½ ': 'ï¸¶',
    'ï½¡': 'ï¸',
    'ï½¢': 'ï¹',
    'ï½£': 'ï¹'
};

export function verticalizePunctuation(input: string) {
    let output = '';

    let prevChar = {premature: true, value: undefined};
    const chars = input[Symbol.iterator]();
    let char = chars.next();
    const nextChars = input[Symbol.iterator]();
    nextChars.next();
    let nextChar = nextChars.next();

    while (!char.done) {
        const canReplacePunctuation = (
            (nextChar.done || !charHasRotatedVerticalOrientation(nextChar.value.codePointAt(0)) || verticalizedCharacterMap[nextChar.value]) &&
            (prevChar.premature || !charHasRotatedVerticalOrientation(prevChar.value.codePointAt(0)) || verticalizedCharacterMap[prevChar.value])
        );

        if (canReplacePunctuation && verticalizedCharacterMap[char.value]) {
            output += verticalizedCharacterMap[char.value];
        } else {
            output += char.value;
        }

        prevChar = {value: char.value, premature: false};
        char = chars.next();
        nextChar = nextChars.next();
    }

    return output;
}

